import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CartProvider } from "../context/CartContext";
import Home from "../view/pages/Home";
import Layout from "../view/components/Layout";
import NewsDetail from "../view/pages/NewsDetail";
import UserView from "../view/pages/UserView";
import NewsList from "../view/pages/NewsList";
import PaymentResult from "../view/pages/PaymentResult";

export const Path = {
  Home: "/",
  Shop: "/shop",
  News: "/news"
};

const MainNavigator = () => {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/shop" element={<UserView />} />
            {/* <Route path="/payment/:status" element={<PaymentResult />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
};

export default MainNavigator;
